module.exports = __webpack_public_path__ + "img/prev-arrow.29ae17e2.svg";